import type { FieldPath } from 'react-hook-form';
import { z } from 'zod';

export const groupFormSchema = z.object({
    name: z.string().min(1, { message: 'Required' }),
    description: z.string().optional(),
    enrolledCourseIds: z.array(z.string()).min(1, { message: 'At least one course must be selected' }),
});

export type GroupFormData = z.infer<typeof groupFormSchema>;

export const defaultGroupFormValues: GroupFormData = {
    name: '',
    description: '',
    enrolledCourseIds: [],
};

export const getFieldsToValidate = (): FieldPath<GroupFormData>[] => {
    return ['name'];
};
